import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './styles/mobile-menu.scss';
import StoreAPI from '../../../apis/store';
import ZoneService from '../../../services/zone-service';
import APP_DEFAULTS from '../../../constants/app-defaults';
import spreeStore from '../../../store';

class MobileMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elementSelected: '',
            menu: [],
            seeAll: false,
        };

        this.selectMenuItem = this.selectMenuItem.bind(this);
        this.toggleFirstMenu = this.toggleFirstMenu.bind(this);
        this.toggleSecondMenu = this.toggleSecondMenu.bind(this);
        this.handleClickOnStoreAndZone = this.handleClickOnStoreAndZone.bind(this);
        this.buildMenu = this.buildMenu.bind(this);
    }

    componentDidMount() {
        StoreAPI.getGroupedStores().then((response) => {
            this.buildMenu(response.body.zones, response.body.data, this.props.currentZone, this.props.multiCountryShipping);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const prevZones = prevProps.storesGrouped.zones || [];
        const prevStores = prevProps.storesGrouped.data || {};
        const currentZones = this.props.storesGrouped.zones || [];
        const currentStores = this.props.storesGrouped.data || {};

        if (currentZones.length > 0 && Object.keys(currentStores).length > 0
            && (prevProps.locale.currentLocale !== this.props.locale.currentLocale
                || (prevProps.currentZone !== this.props.currentZone && this.props.multiCountryShipping)
                || (prevZones !== currentZones && this.props.multiCountryShipping)
                || (prevStores !== currentStores && this.props.multiCountryShipping)
                || (prevProps.currentStore.id !== this.props.currentStore.id)
                || prevProps.multiCountryShipping !== this.props.multiCountryShipping)) {
            this.buildMenu(currentZones, currentStores, this.props.currentZone, this.props.multiCountryShipping);
        }
    }

    // eslint-disable-next-line react/sort-comp
    buildMenu(zones, stores, currentZone, multiStore) {
        if (zones.length > 0 && Object.keys(stores).length > 0) {
            const tmpMenu = [{
                label: this.props.currentStore.name,
                id: this.props.currentStore.id,
                type: 'link',
            },
            {
                label: multiStore
                    ? ZoneService.getNameCurrentZone(zones, currentZone)
                    : this.props.intl.formatMessage({ id: 'for-cuba' }),
                id: 2,
                type: 'first_level',
                items: zones.map((zone) => {
                    const zoneTmp = {
                        type: 'second_level',
                        label: zone.name,
                        id: zone.id,
                        items: [],
                    };
                    if (stores[zone.id]) {
                        zoneTmp.items = stores[zone.id].map((item) => {
                            const store = {
                                id: item.id,
                                label: item.name,
                            };
                            return store;
                        });
                    }
                    return zoneTmp;
                }),
            }];
            this.setState((prevState) => ({ menu: tmpMenu }));
        }
    }

    selectMenuItem(element) {
        this.setState((prevState) => ({
            elementSelected: prevState.elementSelected !== element ? element : '',
        }));
    }

    toggleFirstMenu(parentId) {
        const tmpMenu = [...this.state.menu];

        tmpMenu.forEach((item) => {
            if (item.id === parentId) {
                item.open = !item.open;
            } else {
                item.open = false;
            }
        });
        this.setState((prevState) => ({ menu: tmpMenu }));
    }

    toggleSecondMenu(parentId, childId) {
        const tmpMenu = [...this.state.menu];

        tmpMenu.forEach((item) => {
            if (item.id === parentId) {
                item.items.forEach((subittem) => {
                    if (subittem.id === childId) {
                        subittem.open = !subittem.open;
                    } else {
                        subittem.open = false;
                    }
                });
            }
        });
        this.setState((prevState) => ({ menu: tmpMenu }));
    }

    // eslint-disable-next-line class-methods-use-this
    handleClickOnStoreAndZone(zoneId, storeId) {
        // const selectStored = this.props.stores.find((store) => store.id === storeId);
        // this.props.setCurrentStore(selectStored);
        //
        // if (zoneId) {
        //     this.props.setCurrentZone(zoneId);
        // }
        //
        // this.props.toggleMobileMenu();
        //
        // const to = `${this.props.location.pathname !== '/' ? this.props.location.pathname : APP_ROUTES.searchPageRoute}?`
        //     + `store_id=${storeId}`
        //     + `${zoneId ? `&zone_id=${zoneId}` : ''}`;
        // this.props.history.push(to);
        this.props.toggleMobileMenu();
        this.props.handleClickOnStoreAndZone(zoneId, storeId);
    }

    setSeeAll(value) {
        this.setState((previewState) => ({ seeAll: value }));
    }

    getCurrentMunicipality() {
        const { municipalities: { availableMunicipalities = [] } } = spreeStore.getState();
        return availableMunicipalities && availableMunicipalities.length > 0 && availableMunicipalities.find((mun) => mun.id === this.props.currentMunicipality);
    }

    render() {
        return (
            <div
                className={styles.mobileMenu}
                style={{
                    display: this.props.showMobileMenu ? 'initial' : 'none',
                    height: '100vh',
                }}
            >
                <div className={`container ${styles.menuTop}`}>
                    <div className="row">
                        <div
                            className="col-xs-12"
                            style={{
                                fontWeight: 'bold', fontSize: 'x-large',
                            }}
                        >
                            <div className={styles.menuBorder}>
                                <FormattedMessage id="menu" defaultMessage="Menu" />
                                <i
                                    onClick={this.props.toggleMobileMenu}
                                    className={`pe-7s-close pe-1x pe-va font-weight-bold ${styles.angleDown}`}
                                    style={{ position: 'absolute', right: '10px' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <ul className={`nav navbar-nav ${styles.menu}`} style={{ fontSize: 'large', fontWeight: 'bold', width: '100%' }}>
                            {/* eslint-disable-next-line array-callback-return */}
                            {this.state.menu.map((firstLevelMenu, index) => {
                                if (firstLevelMenu.type === 'link') {
                                    return (
                                        <li key={`${firstLevelMenu.id}-${index}`} style={{ width: '100%' }}>
                                            <a onClick={() => this.handleClickOnStoreAndZone(undefined, firstLevelMenu.id)}>{firstLevelMenu.label}</a>
                                        </li>
                                    );
                                } if (firstLevelMenu.type === 'first_level') {
                                    return (
                                        <li key={`${firstLevelMenu.id}-${index}`} className={`dropdown ${styles.menuItem}`} style={{ width: '100%' }}>
                                            <a
                                                className="dropdown-toggle line-double font-weight-bold"
                                                data-toggle="dropdown"
                                                onClick={() => this.toggleFirstMenu(firstLevelMenu.id)}
                                                style={{ color: APP_DEFAULTS.theme.mobileMenuItemColor, display: 'inline-block', width: '100%' }}
                                            >
                                                {firstLevelMenu.label}
                                                {this.getCurrentMunicipality() ? ` - ${this.getCurrentMunicipality().name}` : ' '}
                                                <i
                                                    className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${styles.angleDown}`}
                                                    style={{ display: firstLevelMenu.open ? 'none' : 'inline-block', position: 'absolute', right: '10px' }}
                                                />
                                                <i
                                                    className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${styles.angleUp}`}
                                                    style={{ display: firstLevelMenu.open ? 'inline-block' : 'none', position: 'absolute', right: '10px' }}
                                                />
                                            </a>
                                            <ul className="" style={{ display: firstLevelMenu.open ? 'block' : 'none', paddingLeft: '30px' }}>
                                                {firstLevelMenu.items.map((item) => (
                                                    <li key={item.id} className="">
                                                        <a
                                                            className="dropdown-toggle line-double"
                                                            data-toggle="dropdown"
                                                            onClick={() => {
                                                                this.toggleSecondMenu(firstLevelMenu.id, item.id);
                                                            }}
                                                            style={{
                                                                color: item.open ? APP_DEFAULTS.theme.mobileMenuSubitemColor : 'black',
                                                                display: 'inline-block',
                                                                width: '100%',
                                                                paddingTop: 3,
                                                                paddingBottom: 3,
                                                            }}
                                                        >
                                                            {item.label}
                                                            {' '}
                                                            <i
                                                                className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${styles.angleUp}`}
                                                                style={{ display: item.open ? 'inline-block' : 'none', position: 'absolute', right: '10px' }}
                                                            />
                                                            <i
                                                                className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${styles.angleUp}`}
                                                                style={{ display: !item.open ? 'inline-block' : 'none', position: 'absolute', right: '10px' }}
                                                            />
                                                        </a>
                                                        <ul
                                                            className={`${styles.menu}`}
                                                            style={{ color: '#d3af71', display: item.open ? 'inline-block' : 'none', paddingLeft: '20px' }}
                                                        >
                                                            {!this.state.seeAll && item.items.length > 20 ? item.items.slice(0, 19).map((subitem) => (
                                                                <li key={subitem.id} className={`pe - 1x pe-va font-weight-bold ${styles.menuItem}`}>
                                                                    <a style={{ fontWeight: 'bold' }} onClick={() => this.handleClickOnStoreAndZone(item.id, subitem.id)}>{subitem.label}</a>
                                                                </li>
                                                            ))
                                                                : item.items.map((subitem) => (
                                                                    <li key={subitem.id} className={`pe - 1x pe-va font-weight-bold ${styles.menuItem}`}>
                                                                        <a style={{ fontWeight: 'bold' }} onClick={() => this.handleClickOnStoreAndZone(item.id, subitem.id)}>{subitem.label}</a>
                                                                    </li>
                                                                ))}
                                                            {!this.state.seeAll && item.items.length > 20 ? (
                                                                <li className={styles.rowSeeAll}>
                                                                    <div>
                                                                        <a
                                                                            className="font-weight-bold"
                                                                            onClick={() => this.setSeeAll(true)}
                                                                        >
                                                                            <FormattedMessage id="see-all" defaultMessage="See all" />
                                                                        </a>
                                                                    </div>
                                                                </li>
                                                            ) : null}

                                                            {this.state.seeAll && item.items.length > 20 ? (
                                                                <li className={styles.rowSeeAll}>
                                                                    <div>
                                                                        <a
                                                                            className="font-weight-bold"
                                                                            onClick={() => this.setSeeAll(false)}
                                                                        >
                                                                            <FormattedMessage id="see-less" defaultMessage="See less" />
                                                                        </a>
                                                                    </div>
                                                                </li>
                                                            ) : null}
                                                        </ul>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(injectIntl(MobileMenu));



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/mobile-menu.jsx
 **/